import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

// Note: section as a css variable
export const SectionTitle = styled('h2')`
  ${({ theme }) => theme.typography.megaStrong}
  margin: 0 0 ${({ theme }) => theme.x1spacePx}px;
  &:before {
    content: counter(section);
    opacity: 0.2;
    display: inline-block;
    padding-right: ${({ theme }) => theme.x2spacePx}px;
    ${({ theme }) => theme.typography.mega}
    line-height: 0.75;
  }
`;

export const SnowflakeScore = styled.div`
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  h4 {
    ${({ theme }) => theme.typography.xSmall}
    margin-top: 0;
    margin-bottom: ${({ theme }) => theme.x1spacePx / 2}px;
    line-height: 1;
  }
  ${media.lgUp`
		position: absolute;
		right: ${({ theme }) => theme.x4spacePx}px;
		top: ${({ theme }) => theme.x4spacePx}px;
	`};
`;

export const Description = styled('p')`
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;
`;

export const ScoreLabel = styled('span')`
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  ${({ theme }) => theme.typography.xSmall};
  padding: 0 ${({ theme }) => theme.x1space}px;
`;
